export class StateModel {
  id : Number;
  state_code : Number;
  state_name : String;
  parent_state_id : Number;
  short_code : String;
  region_name : String;
  region_id : Number;
  state_year : Number;
  stateName : string;
}

export class ReportDataModel {
  brand_end_date: string;
  brand_start_date: string;
  cooler_end_date: string;
  cooler_start_date: string;
  eng_end_date: string;
  eng_start_date: string;
  region_name: string;
  report_data: string;
  state_code: string;
  state_name: string;
  report_name : string;
}

export class MenuSpocEmailModel {
  id: number;
  spoc_email: string;
  region_id: number;
  state_code: number;
  is_default: any;
  status : any;
  created_date : string;
  updated_date : string;
  state_name : string;
  region_name: string;
  statusString: string;
  defalutString: string;
}
